export default __webpack_public_path__ + "2ceef56611922606703764fcadb408e6.svg";